module.exports = __webpack_public_path__ + "static/media/Georgia Pacific.cf13ad54.svg";